import { createContext } from "react";

const SessionContext = createContext<any>(null);

export default SessionContext;